export default [
  {
    path: '/activity',
    name: 'activity',
    component: () => import('@/views/menu/activity/activity.vue'),
    meta: {
      pageTitle: 'مدیریت فعالیت ها',
      action: 'show',
      resource: 'ActivityManager',
    },
  },
  {
    path: '/activity/details',
    name: 'addactivity',
    component: () => import('@/views/menu/activity/activitydetails.vue'),
    meta: {
      pageTitle: 'ایجاد فعالیت',
      action: 'show',
      resource: 'ActivityManager',
    },
  },
  {
    path: '/activity/details/:id',
    name: 'updateactivity',
    component: () => import('@/views/menu/activity/activitydetails.vue'),
    meta: {
      pageTitle: 'ویرایش فعالیت',
      action: 'show',
      resource: 'ActivityManager',
    },
  },
  {
    path: '/activitycategory',
    name: 'activitycategory',
    component: () => import('@/views/menu/activity/activitycategory.vue'),
    meta: {
      pageTitle: 'مدیریت دسته بندی فعالیت',
      action: 'show',
      resource: 'ActivityCategoryManager',
    },
  },
  {
    path: '/activitycategory/details',
    name: 'addactivitycategory',
    component: () => import('@/views/menu/activity/activitycategorydetails.vue'),
    meta: {
      pageTitle: 'ایجاد دسته بندی فعالیت',
      action: 'show',
      resource: 'ActivityCategoryManager',
    },
  },
  {
    path: '/activitycategory/details/:id',
    name: 'updateactivitycategory',
    component: () => import('@/views/menu/activity/activitycategorydetails.vue'),
    meta: {
      pageTitle: 'ویرایش دسته بندی فعالیت',
      action: 'show',
      resource: 'ActivityCategoryManager',
    },
  },
  {
    path: '/muscle',
    name: 'muscle',
    component: () => import('@/views/menu/activity/muscle.vue'),
    meta: {
      pageTitle: 'مدیریت عضله ها',
      action: 'show',
      resource: 'ActivityManager',
    },
  },
  {
    path: '/muscle/details',
    name: 'addmuscle',
    component: () => import('@/views/menu/activity/muscledetails.vue'),
    meta: {
      pageTitle: 'ایجاد عضله',
      action: 'show',
      resource: 'ActivityManager',
    },
  },
  {
    path: '/muscle/details/:id',
    name: 'updatemuscle',
    component: () => import('@/views/menu/activity/muscledetails.vue'),
    meta: {
      pageTitle: 'ویرایش عضله',
      action: 'show',
      resource: 'ActivityManager',
    },
  },
  {
    path: '/activitypackage',
    name: 'activitypackage',
    component: () => import('@/views/menu/activity/activitypackage.vue'),
    meta: {
      pageTitle: 'مدیریت برنامه های ورزشی',
      action: 'show',
      resource: 'ActivityPackageManager',
    },
  },
  {
    path: '/activitypackage/details',
    name: 'addactivitypackage',
    component: () => import('@/views/menu/activity/activitypackagedetails.vue'),
    meta: {
      pageTitle: 'ایجاد برنامه ورزشی',
      action: 'show',
      resource: 'ActivityPackageManager',
    },
  },
  {
    path: '/activitypackage/details/:id',
    name: 'updateactivitypackage',
    component: () => import('@/views/menu/activity/activitypackagedetails.vue'),
    meta: {
      pageTitle: 'ویرایش برنامه ورزشی',
      action: 'show',
      resource: 'ActivityPackageManager',
    },
  },
  {
    path: '/activitypackagecourse',
    name: 'activitypackagecourse',
    component: () => import('@/views/menu/activity/activitypackagecourse.vue'),
    meta: {
      pageTitle: 'مدیریت دوره های ورزشی',
      action: 'show',
      resource: 'ActivityPackageCourseManager',
    },
  },
  {
    path: '/activitypackagecourse/details',
    name: 'addactivitypackagecourse',
    component: () => import('@/views/menu/activity/activitypackagecoursedetails.vue'),
    meta: {
      pageTitle: 'ایجاد دوره ورزشی',
      action: 'show',
      resource: 'ActivityPackageCourseManager',
    },
  },
  {
    path: '/activitypackagecourse/details/:id',
    name: 'updateactivitypackagecourse',
    component: () => import('@/views/menu/activity/activitypackagecoursedetails.vue'),
    meta: {
      pageTitle: 'ویرایش دوره ورزشی',
      action: 'show',
      resource: 'ActivityPackageCourseManager',
    },
  },
  {
    path: '/activitygroup',
    name: 'activitygroup',
    component: () => import('@/views/menu/activity/activitygroup.vue'),
    meta: {
      pageTitle: 'مدیریت گروه های ورزشی',
      action: 'show',
      resource: 'ActivityGroupManager',
    },
  },
  {
    path: '/activitygroup/details',
    name: 'addactivitygroup',
    component: () => import('@/views/menu/activity/activitygroupdetails.vue'),
    meta: {
      pageTitle: 'ایجاد گروه ورزشی',
      action: 'show',
      resource: 'ActivityGroupManager',
    },
  },
  {
    path: '/activitygroup/details/:id',
    name: 'updateactivitygroup',
    component: () => import('@/views/menu/activity/activitygroupdetails.vue'),
    meta: {
      pageTitle: 'ویرایش گروه ورزشی',
      action: 'show',
      resource: 'ActivityGroupManager',
    },
  },
  {
    path: '/activitycomment',
    name: 'activitycomment',
    component: () => import('@/views/menu/activity/activitycomment.vue'),
    meta: {
      pageTitle: 'مدیریت نظرها',
      action: 'show',
      resource: 'ActivityCommentManager',
    },
  },
  {
    path: '/activitypackagecomment',
    name: 'activitypackagecomment',
    component: () => import('@/views/menu/activity/activitypackagecomment.vue'),
    meta: {
      pageTitle: 'مدیریت نظرها',
      action: 'show',
      resource: 'ActivityPackageCommentManager',
    },
  },
]
